import calendar from './../util/calendar';

export default {
  init() {

  },
  finalize() {

    calendar.instantiate();
    calendar.populateCalendarMonth($('.tr-calendar-wrap').data('month-offset'));

    /* Was going to use Date.prototype.format but there is no documentation on this online and it seems to just be Chrome experimental for now */
    function formatDate(dateObject, form) {
      var date = '';

      for (var i = 0; i < form.length; i++) {
        const char = form.charAt(i);

        if (char == 'j') {
          const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
          date += days[dateObject.getDay()];
        } else if (char == 'd') {
          date += (dateObject.getDate() / 10).toString().replace('.', '');
        } else if (char == 'M') {
          const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
          date += months[dateObject.getMonth()];
        } else if (char == 'm') {
          date += ((dateObject.getMonth() + 1) / 10).toString().replace('.', '');
        } else if (char == 'Y') {
          date += dateObject.getFullYear();
        } else {
          date += char;
        }
      }

      return date;
    }

    function checkEverythingIsOk() {

      $('#confirm-btn').prop('disabled', true);

      // 1. Check the time not available message is not showing
      if ($('#error-time-not-available').hasClass('d-none')) {

        // 2. Check the tickets are delegated appropriately
        const numberVisiting = $('.number-visiting-btn.active').data('number');

        var ticketsSelected = 0;
        $('.ticket-types-wrap .assign-box').each(function() {
          ticketsSelected += ($(this).find('.box-quantifier').data('quantity') * $(this).data('default-quantity'));
        });

        if (numberVisiting == ticketsSelected) {

          // 3. Check a name has been entered
          if ($('input[name="bookers-name"]').val() != '') {

            // 4. Check a date & time has been selected
            if ($('select[name="visit-time"] option:selected').length > 0) {
              if ($('select[name="visit-time"] option:selected').data('places-available') > 0) {

                // Everything should be ok
                $('#confirm-btn').prop('disabled', false);

              }
            }

          }

        }

      }
      
      setTicketsToAssign(); 

    }

    function checkVisitorQuantity() {
      const currentNumber = $('.number-visiting-btn.active').data('number');

      if ($('.visit-time-changer option:selected').length > 0) {
        const selectedAvailable = $('.visit-time-changer option:selected').data('places-available');

        if (currentNumber > selectedAvailable) {
          $('#error-time-not-available').removeClass('d-none');
        } else {
          $('#error-time-not-available').addClass('d-none');
        }
        
        checkEverythingIsOk();
      }
    }

    // Change booker name
    $('input[name="bookers-name"]').on('change', function() {
      checkEverythingIsOk();
    });

    // Set number visiting
    $('.number-visiting-btn').on('click', function() {
      $('.number-visiting-btn.active').removeClass('active');
      $(this).addClass('active');
      
      checkVisitorQuantity();
    });

    // Delegate tickets
    $('.ticket-types-wrap .quantifier-less').on('click', function() {
      const quantity = parseInt($(this).parent().data('quantity'));

      if (quantity > 0) {
        $(this).parent().data('quantity', quantity - 1);
        $(this).siblings('.quantifier-total').html(quantity - 1);
      }

      checkEverythingIsOk();
    });
    
    $('.ticket-types-wrap .quantifier-more').on('click', function() {
      const ticketsToAssign = parseInt($('.prompt-remaining .prompt-remaining-quantity').html());
      const quantity = parseInt($(this).parent().data('quantity'));
      const defaultQuantity = $(this).parents('.assign-box').data('default-quantity');

      if (ticketsToAssign - defaultQuantity >= 0) {
        $(this).parent().data('quantity', quantity + 1);
        $(this).siblings('.quantifier-total').html(quantity + 1);
      }
      
      checkEverythingIsOk();
    });
    
    // Select visit date
    $('.tr-calendar-wrap .tr-calendar-body .tr-calendar-week-day').on('click', function() {
      if ($(this).data('available')) {
        const $this_ = $(this);

        $('.tr-calendar-wrap .tr-calendar-body .tr-calendar-week-day.selected').each(function() {
          if ($(this).get()[0] != $this_.get()[0]) {
            $(this).removeClass('selected');
          }
        });

        $(this).addClass('selected');

        const fullDate = $(this).data('full-date');
        $('.tr-calendar-wrap').data('chosen-date', fullDate);
        $('input[name="tr_date_selection"]').val(fullDate);

        const dateSelectedFormatted = new Date(fullDate.split('-').reverse().join('-'));
  
        // Clear visit times
        $('.visit-time-changer').empty();

        // Disable date field temporarily
        $('.tr-calendar-wrap').addClass('disabled');
        $('.visit-time-changer').prop('disabled', true);
        $('.visit-time-spinner').removeClass('d-none');
        $('#error-failed-to-load-times').addClass('d-none');
  
        // Get times
        $.ajax({
          url: '/wp-json/booking/get-available-timeslots',
          method: 'GET',
          data: {
            day: dateSelectedFormatted.getDate(),
            month: dateSelectedFormatted.getMonth() + 1,
            year: dateSelectedFormatted.getFullYear(),
            includePlacesAvailable: true,
            includeFormatted: true,
            // excludeBookingId: lastEditingId,
          },
        }).done(function(timeslots) {
  
          if (timeslots) {
            timeslots.forEach((timeslot) => {
              const $timeslotItem = $(`<option value="${timeslot[0]}" data-places-available="${timeslot[1]}">${timeslot[2]} [${timeslot[1]}]</option>`);
              $('.visit-time-changer').append($timeslotItem);
            });
  
            checkVisitorQuantity();
          }
  
        }).fail(function() {
          $('#error-failed-to-load-times').removeClass('d-none');
        })
        .always(function() {
          $('.tr-calendar-wrap').removeClass('disabled');
          $('.visit-time-changer').prop('disabled', false);
          $('.visit-time-spinner').addClass('d-none');
        });


      }

    });

    // Change time
    $('.visit-time-changer').on('change', function() {
      checkVisitorQuantity();
    });

    // Undo changes
    $('#undo-btn').on('click', function() {
      // Clear bookers name
      $('input[name="bookers-name"]').val('');

      // Clear bookers email
      $('input[name="bookers-email"]').val('');

      // Clear number visiting
      $('.number-visiting-btn').removeClass('active');

      // Clear ticket delegation
      $('.ticket-types-wrap .assign-box').each(function() {
        $(this).find('.box-quantifier').data('quantity', '0');
        $(this).find('.quantifier-total').html('0');
      });

      // Clear visit date
      $('.tr-calendar-wrap .tr-calendar-week-day.selected').removeClass('selected');

      // Clear visit time
      $('.visit-time-changer').find('option:not([value=""])').remove();

      // Clear additional info
      $('textarea[name="additional-information"]').val('');

      // It's not ok
      checkEverythingIsOk();
    });

    function getAttendeesArray() {
      var pu_attendees = [];

      $('.ticket-types-wrap .assign-box').each(function() {
        const quantity = parseInt($(this).find('.box-quantifier').data('quantity'));

        if (quantity > 0) {
          pu_attendees.push({
            'ticket_type': $(this).data('slug'),
            'slug': $(this).data('slug'), // Different endpoints look for different things, this should be standardised really.
            'quantity': quantity,
          });
        }
      });

      return pu_attendees;
    }

    //// Ticket delegation
    // Set the 'tickets to assign' based on chosen tickets
    function setTicketsToAssign() {
      const quantityToAssign = $('.number-visiting-btn.active').data('number');

      var quantityAssigned = 0;
      $('.assign-box').each(function() {
        quantityAssigned += $(this).find('.box-quantifier').data('quantity') * $(this).data('default-quantity');
      });

      if (quantityAssigned > quantityToAssign) {
        // Too many have been assigned. Just clear them all and restart.
        quantityAssigned = 0;
        $('.assign-box').each(function() {
          $(this).find('.box-quantifier').data('quantity', 0);
          $(this).find('.box-quantifier .quantifier-total').html('0');
        });
      }
      
      const quantityRemaining = quantityToAssign - quantityAssigned;

      $('.prompt-remaining .prompt-remaining-quantity').html(quantityRemaining);

      // Plural/Single
      if (quantityRemaining == 1) {
        $('.prompt-remaining .prompt-remaining-ticket-single').removeClass('d-none');
        $('.prompt-remaining .prompt-remaining-ticket-plural').addClass('d-none');
      } else {
        $('.prompt-remaining .prompt-remaining-ticket-single').addClass('d-none');
        $('.prompt-remaining .prompt-remaining-ticket-plural').removeClass('d-none');
      }
    }

    // Confirm booking go to next page
    $('#confirm-btn').on('click', function() {
      
      $('#confirm-btn').prop('disabled', true);
      $('.create-a-booking-container').addClass('disabled');
      $('.create-a-booking-confirm-spinner').removeClass('d-none');

      const dateSelected = new Date($('.tr-calendar-wrap .tr-calendar-week-day.selected').data('full-date').split('-').reverse().join('-'));

      const pu_timeSlot = $('.visit-time-changer option:selected').val();
      const pu_day = formatDate(dateSelected, 'd');
      const pu_month = formatDate(dateSelected, 'm');
      const pu_year = formatDate(dateSelected, 'Y');
      const pu_attendees_array = getAttendeesArray();
      const pu_attendees = btoa(JSON.stringify(pu_attendees_array));

      const failedValidation = (failMessage) => {
        $('.create-a-booking-container').removeClass('disabled');
        $('#confirm-btn').prop('disabled', false);
        $('.create-a-booking-confirm-spinner').addClass('d-none');

        $('#general-form-error').removeClass('d-none');
        $('#general-form-error').html(failMessage);

        // Scroll to top
        $('.create-a-booking-content').animate({
          scrollTop: 0,
        }, 500);
      }

      // Validate everything is ok.
      $.ajax({
        url: '/wp-json/booking/validate',
        method: 'GET',
        data: {
          timeslot: pu_timeSlot,
          day: pu_day,
          month: pu_month,
          year: pu_year,
          attendees: pu_attendees,
        },
      }).done(function(validation_response) {

        if (validation_response !== false) {

          // All is ok. Price up
          $.ajax({
            url: '/wp-json/booking/price-up',
            method: 'GET',
            data: {
              timeslot: pu_timeSlot,
              day: pu_day,
              month: pu_month,
              year: pu_year,
              attendees: pu_attendees,
            },
          }).done(function(price) {

            // Price is ready. Get ready to add to basket and show confirmation screen.
            
            // 1. Append booking type data
            const data = {
              visitorTypes: pu_attendees_array,
              date: (new Date(pu_year + '-' + pu_month + '-' + pu_day)).getTime(),
              time: pu_timeSlot,
              additionalInfo: $('textarea[name="additional-information"]').prop('value'),
              bookingType: $('.booking-type-changer').val(),
              name: $('input[name="bookers-name"]').val(),
              email: $('input[name="bookers-email"]').val(),
            };

            const dataFriendly = JSON.stringify(data);

            const date = new Date();
            date.setTime(date.getTime() + (24 * 60 * 60 * 1000));

            const cookieExpiration = date.toUTCString();

            // 2. Data added as cookie
            document.cookie = `booking_data=${dataFriendly};expires=${cookieExpiration};path=/`;

            // Set the data on the confirmation page.
            $('#vab-order-name').html($('input[name="bookers-name"]').val());
            $('#vab-order-email').html($('input[name="bookers-email"]').val());
            $('.confirm-vab-number-visiting').html($('.number-visiting-btn.active').data('number'));

            pu_attendees_array.forEach((ticket_type) => {
              const ticketTypeSlug = ticket_type.ticket_type;
              const $ticketTypeItem = $(`.assign-box[data-slug="${ticketTypeSlug}"]`);
              const ticketTypeName = $ticketTypeItem.data('name');
              const ticketTypePrice = '&pound;' + parseFloat($ticketTypeItem.data('price')).toFixed(2);

              const $elementTicketItem = $(`
                <div class="confirm-vab-ticket-item">
                  <div class="confirm-vab-ticket-item-name">${ticket_type.quantity} x ${ticketTypeName}</div>
                  <div class="confirm-vab-ticket-item-amount">${ticketTypePrice}</div>
                </div>
              `);

              $('.confirm-vab-ticket-breakdown').append($elementTicketItem);
            });

            const dateFriendly = formatDate(dateSelected, 'j, d M. Y');

            $('.confirm-vab-visit-date').html(dateFriendly);
            $('.confirm-vab-visit-time').html($('.visit-time-changer option:selected').html());

            $('.confirm-vab-total-amount').html('&pound;' + parseFloat(price).toFixed(2));

            $('.confirm-vab-additional-notes-text').html($('.additional-info-text').val());

            $('.create-a-booking-container').removeClass('disabled');
            $('#general-form-error').addClass('d-none');

            // Go to page confirmation page.
            $('#page-create-booking').addClass('d-none');
            $('#page-confirm-booking').removeClass('d-none');

            $('#page-create-booking-footer').addClass('d-none');
            $('#page-confirm-booking-footer').removeClass('d-none');

            $('#page-title-create').addClass('d-none');
            $('#page-title-summary').removeClass('d-none');

          }).fail(function(jqXHR, textStatus, errorThrown) {
            failedValidation(jqXHR.responseText);
          });

        } else {
          failedValidation('Time validation failed. Please try again.');
        }

      }).fail(function(jqXHR, textStatus, errorThrown) {
        failedValidation(jqXHR.responseText);
      });

    });

    // Proceed button is clicked, add to basket and leave for payment
    $('#proceed-btn').on('click', function() {
      $(this).prop('disabled', true);

      // 3. Proceed button appears and runs this ajax request goes to add_product_to_basket endpoint
      // run a query to add the booking product to the basket
      $.ajax({
        url: '/wp-json/booking/add-product-to-basket',
        method: 'GET',
      }).done(function(e) {

        // 3. Head to the checkout (URL sent by endpoint)
        window.location.replace(e);

      }).fail(function(jqXHR, textStatus, errorThrown) {
        $(this).prop('disabled', false);

        $('#general-form-error').removeClass('d-none');
        $('#general-form-error').html(jqXHR.responseText);

        // Scroll to top
        $('.create-a-booking-content').animate({
          scrollTop: 0,
        }, 500);
      });

    });
  },
}


// WEBPACK FOOTER //
// ./scripts/routes/templateBookingManagerCreateABooking.js